const BIRRE_SPINA = "Birre alla spina";

export const isBeer = (val) => val === BIRRE_SPINA;

export const isWine = (val) => val.startsWith("Vini") || val.startsWith("Vino");

export const isBurger = (val) => val.startsWith("Panini");